import { Link } from "react-router-dom";
import { ArrowRight, Zap } from "lucide-react";

// Photo-free service card: icon, category, copy, and a two-item work preview.
export default function ServiceCard({ to, Icon, name, category, short, workTypes = [], index, testId }) {
  return (
    <Link to={to} data-testid={testId} className="kx-card kx-card-hover group relative flex h-full flex-col overflow-hidden p-7">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-400/70 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      <span className="pointer-events-none absolute -bottom-3 right-4 select-none font-display text-7xl font-extrabold text-white/[0.035]">
        {String(index + 1).padStart(2, "0")}
      </span>
      <div className="flex items-start justify-between gap-3">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl border border-amber-400/20 bg-amber-400/10 text-amber-400 transition-colors duration-300 group-hover:bg-amber-400 group-hover:text-[#0A0A0C]">
          <Icon className="h-6 w-6" />
        </div>
        <span className="rounded-full border border-[#2a2a34] px-2.5 py-1 text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-neutral-400">
          {category}
        </span>
      </div>
      <h2 className="mt-6 font-display text-2xl font-bold uppercase leading-tight text-white">{name}</h2>
      <p className="mt-2 text-sm leading-relaxed text-neutral-400">{short}</p>
      {workTypes.length > 0 && (
        <ul className="mt-4 flex-1 space-y-1.5">
          {workTypes.slice(0, 2).map((w) => (
            <li key={w} className="flex items-start gap-2 text-sm text-neutral-300">
              <Zap className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-400" />
              {w}
            </li>
          ))}
        </ul>
      )}
      <span className="mt-6 inline-flex items-center gap-1 border-t border-[#20202a] pt-4 text-sm font-semibold text-amber-400">
        Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
